/**
 * @module views\sys\tableConfig
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import TableColumn from "@/components/ghTable/dataTable/tableColumn/tableColumn";
@Component({
  components: {
    TableColumn
  }
})
export default class TableConfig extends GhBase {
  protected title = "数据表配置";
  private tableId = "";
  protected onNavigateTo(param) {
    this.tableId = param.tableId;
  }
}
